import React from "react";
import BaseModal from "../BaseModal";
import {
  DISABLING_SHARED_SECRET,
  SECRET_SAFETY_MEASURE,
  CONFIRM_DISABLING_SHARED_SECRET,
  ENTER_DELETE_TO_CONFIRM,
  REVOKE_SHARED_SECRET_PLACEHOLDER,
} from "../../../constants/strings";
import { Field, propTypes, reduxForm } from "redux-form";
import Grid from "@material-ui/core/Grid";
import { REVOKE_SHARED_SECRET_FORM } from "../../../constants/forms";
import Typography from "@material-ui/core/Typography";
import InputWithTitle from "../../InputWithTitle/InputWithTitle";
import PropTypes from "prop-types";
import { uppercase } from "../../../utils/normalize";
import { connect } from "react-redux";
import { compose } from "redux";
import { shouldDisableModalConfirmButton } from "../../../features/userDetailsForm/apiSetting/apiSettingSelectors";
import { revokeSharedSecretValidator } from "../../../features/webhooks";

const RevokeSharedSecretModal = ({ ...otherProps }) => {
  return (
    <BaseModal title={CONFIRM_DISABLING_SHARED_SECRET} {...otherProps}>
      <Grid container spacing={3} style={{ marginBottom: "16px" }}>
        <Grid item xs={12}>
          <Typography variant="body2">{DISABLING_SHARED_SECRET}</Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="body2">{SECRET_SAFETY_MEASURE}</Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="body1" style={{ fontWeight: "bold" }}>
            {ENTER_DELETE_TO_CONFIRM}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Field
            component={InputWithTitle}
            name="deleteConfirmation"
            normalize={uppercase}
            placeholder={REVOKE_SHARED_SECRET_PLACEHOLDER}
          />
        </Grid>
      </Grid>
    </BaseModal>
  );
};

RevokeSharedSecretModal.propTypes = {
  ...propTypes,
  disabledConfirmButton: PropTypes.bool,
};

const mapStateToProps = (state, { initialValues }) => ({
  initialValues,
  disabledConfirmButton: shouldDisableModalConfirmButton(
    REVOKE_SHARED_SECRET_FORM
  )(state),
});

export default compose(
  connect(mapStateToProps),
  reduxForm({
    form: REVOKE_SHARED_SECRET_FORM,
    validate: (values) => revokeSharedSecretValidator(values),
  })
)(RevokeSharedSecretModal);
